import type { SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import type React from "react";
import { translateLanguage } from "../../components/LanguagePickerComponent/getLocalisedLabel";
import { FONTS, fontSize } from "../../styles/fonts";
import type { ReviewTranslations } from "./reviewTranslations";
import { T } from "../../components/T";

export const ReviewTranslatedFrom: React.FC<{
  t: ReviewTranslations;
  locale: SwarovskiOptikLocaleFrontend;
  languageIsoCode: string;
  className?: string;
}> = ({ t, locale, languageIsoCode, className }) => {
  const labelF = (languageIsoCode: string) =>
    translateLanguage({
      uiLanguageIsoCode: locale.language.isoCode,
      languageIsoCodeToBeTranslated: languageIsoCode,
    });

  return (
    <span css={[FONTS.SwarovskiFutura300, fontSize.x2]} className={className}>
      <T forcedValue={t("translatedFrom")}>{t("translatedFrom").value.replace("<value>", labelF(languageIsoCode))}</T>
    </span>
  );
};
